import { render } from "./profitStatistics.vue?vue&type=template&id=95784b3c&scoped=true&ts=true"
import script from "./profitStatistics.vue?vue&type=script&lang=ts"
export * from "./profitStatistics.vue?vue&type=script&lang=ts"

import "./profitStatistics.vue?vue&type=style&index=0&id=95784b3c&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95784b3c"]])

export default __exports__